
const Visualiser = require('../analysis/visualiser')

const Chart = require('chart.js')

const {get} = require('../request')
const {parse} = require('../html')
const layout = require('./keyword.html')
const buttonLayout = require('./keyword_button.html')
const description = require('./keyword_description.html')

const NAME = '키워드 분석'
const COMMON_COLORS = [
    '#17becf', '#bcbd22', '#7f7f7f', '#e377c2', '#8c564b', '#9467bd', '#d62728', '#2ca02c', '#ff7f0e', '#1f77b4',
]
const rgb = (r, g, b) => `rgba(${r}, ${g}, ${b})`
const randInt = (min, max) => Math.round(Math.random() * (max - min)) + min
const randColor = () => rgb(randInt(0, 255), randInt(0, 255), randInt(0, 255))
const toMap = (entries) => entries.reduce((a, c) => (a[c[0]] = c[1], a), {})

const Keyword = class extends Visualiser {
    constructor(analysis, options={}) {
        super(NAME, analysis, {
            width: options.width || 1024,
            height: options.height || 512,
            keywords: options.keywords || [],
            colorIndex: options.colorIndex || 0
        })
    }
    parseInputs(form) {
        const keyword = form.querySelector('#keyword').value
        return {keyword}
    }
    dom() {
        const content = parse(layout, {}).querySelector('#content')
        this.content = content

        const form = content.querySelector('form#add')
        form.addEventListener('submit', (event) => {
            event.preventDefault()
            const {keyword} = this.parseInputs(form)
            const color = this.newColour()
            this.options.keywords.push({text: keyword, color})
            this.update()
            form.querySelector('#keyword').value = ''
            return true
        })

        return content
    }
    update() {
        const {keywords, width, height} = this.options
        const wrapper = this.content.querySelector('#chart-wrapper')

        const {host, port} = this.api
        get(host, port, `/document/${this.document.name}/tokens`, this.config.json()).then(({units}) => {
            const data = Object.entries(units).map(([i, unit]) => {
                const {name, frequency} = unit
                const index = parseInt(i)
                return {index, name, frequency: toMap(Object.entries(frequency).map(([t, f]) => [t.split('/')[0], f]))}
            })
            
            const chart = () => {
                const canvas = document.createElement('canvas')
                canvas.width = width
                canvas.height = height
                canvas.style.display = 'inline-block'
                canvas.classList.add('keyword')
        
                wrapper.innerHTML = ''
                wrapper.appendChild(canvas)
        
                new Chart(canvas.getContext('2d'), {
                    type: 'line',
                    data: {
                        datasets: keywords.map(({text, color}) => ({
                            label: text,
                            data: data.map(({frequency}) => frequency[text] || 0),
                            backgroundColor: 'transparent',
                            borderColor: color,
                        })),
                        labels: data.map(unit => unit.name),
                    },
                    options: {
                        responsive: false,
                        legend: {
                            display: false,
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                }
                            }],
                            xAxes: [{
                                ticks: {
                                    // callback: (value, index, values) => `단위 ${index+1}`
                                }
                            }],
                        }
                    },
                })
            }

            const updateButtons = () => {
                const buttons = this.content.querySelector('#buttons')
                buttons.innerHTML = ''
                keywords.forEach(({text, color}, i) => {
                    const button = parse(buttonLayout, {text, color}).firstChild
                    button.addEventListener('click', () => {
                        keywords.splice(i, 1)
                        chart()
                        updateButtons()
                    })
                    buttons.appendChild(button)
                })
            }
            chart()
            updateButtons()
        })
    }
    data({word}) {
        const color = this.newColour()
        this.options.keywords.push({text: word, color})
        this.update()
    }
    newColour() {
        return (this.options.colorIndex < COMMON_COLORS.length) ? COMMON_COLORS[this.options.colorIndex++] : randColor()
    }
}

module.exports = {
    name: NAME,
    add: (analysis) => new Keyword(analysis),
    description: description,
}
